<template>
  <div
    class="comment p-2"
    @click.stop>
    <validation-observer
      ref="observer"
      v-slot="{passes}">
      <BaseTextareaWithProvider
        v-model="commentInput"
        placeholder="コメントを入力してください。"
        rows="5" />
      
      <div class="general-form__group form-group mt-3 mt-md-4">
        <FileUploaderWithProvider
          v-if="attachmentOption"
          v-model="file" />
      </div>
      <button
        class="btn btn-l-blue btn-block mt-3"
        @click="passes(onClickAddComment)">
        コメントを追加
      </button>
    </validation-observer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FileUploaderWithProvider from '@/components/parts/FileUploaderWithProvider'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider'

export default {
  components: {
    FileUploaderWithProvider,
    BaseTextareaWithProvider
  },
  props: {
    eventId: {
      type: Number,
      required: true
    },
    refetchEvent: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      commentInput: '',
      file: null
    }
  },
  computed: {
    ...mapGetters('tenant', ['attachmentOption']),
    ...mapGetters('auth', ['isAnyManager']),
  },
  methods: {
    async onClickAddComment() {
      const latestEvent = await this.refetchEvent(this.eventId)
      if (!latestEvent) {
        this.$store.commit('notify/set', {message: 'この予定は削除されました', type: 'danger'})
        return
      }
      if (this.commentInput && this.commentInput !== '' || this.file){
        if (this.isAnyManager) {
          if (latestEvent.isDraft) {
            if (!window.confirm('下書き予定表へのコメントはあなたをフォローする管理者にだけ通知されます')) return
          } else {
            if (!window.confirm('予定表へのコメントはあなたをフォローするすべてのユーザーに通知されます')) return
          }
        } else {
          if (latestEvent.isDraft) {
            this.$store.commit('notify/set', {message: '予定が下書き状態になったためコメントを送信できませんでした', type: 'danger'})
            return
          } else {
            if (!window.confirm('予定表へのコメントはこの予定の作者にだけ通知されます')) return
          }
        }
        this.$emit('create', this.eventId, this.commentInput, this.file)
        this.commentInput = ''
        this.file = null
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.comment{
  background-color: $grey15;
}
</style>